jQuery(document).ready(function ($) {
  if (typeof wp !== "undefined" && wp.domReady) {
    wp.domReady(function () {
      setTimeout(function () {
        initializeFaqs();
      }, 500);
    });
  } else {
    initializeFaqs();
  }

  function initializeFaqs() {
    /* FAQS home page */
    $(".faqs__item").each(function () {
      const $item = $(this);
      const $question = $item.find(".faqs__question");

      $question.on("click", function () {
        const isActive = $item.hasClass("faqs__item--active");

        $(".faqs__item").removeClass("faqs__item--active");

        if (!isActive) {
          $item.addClass("faqs__item--active");
        }
      });
    });
  }
});
